import apiClient from './client';

export const listPayments = (params) => apiClient.get('/payments', { params }).then((r) => r.data);
export const recordPayment = ({ invoiceId, amount, paymentDate, file }) => {
  const formData = new FormData();
  formData.append('invoiceId', invoiceId);
  formData.append('amount', amount);
  if (paymentDate) formData.append('paymentDate', paymentDate);
  if (file) formData.append('file', file);
  return apiClient.post('/payments', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
export const verifyPayment = (id, decision) => apiClient.patch(`/payments/${id}/verify`, { decision }).then((r) => r.data);
